import React from 'react';
import { MdVisibility } from 'react-icons/md';
import { useReadOnly } from '../../hooks/useReadOnly';

/**
 * ReadOnlyBanner
 * Shown inside SignupLayout when isReadOnly is true.
 * Lets the CSR know they are in view-only mode.
 */
export function ReadOnlyBanner() {
    const { isReadOnly } = useReadOnly();
    if (!isReadOnly) return null;

    return (
        <div className="readonly-banner">
            <MdVisibility size={16} className="readonly-banner__icon" />
            <span>Read-only - viewing as CSR. No changes will be saved.</span>
        </div>
    );
}